// THIS CODE IS GENERATED. DO NOT MODIFY
/* istanbul ignore next */
(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csProjectV7', ['bmHttpUtils', 'bluemoon.components.session']).service('csProjectV7',
        ['$http', 'bmHttpUtils', 'AuthenticatedSessionData',
        function($http, bmHttpUtils, authenticatedSessionData) {
            return {
                getList: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_GetList endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'orderBy': paramsCopy['orderBy'],
                            'search': paramsCopy['search'],
                            'searchBy': paramsCopy['searchBy'],
                            'filter': paramsCopy['filter'],
                            'startIndex': paramsCopy['startIndex'],
                            'pageIndex': paramsCopy['pageIndex'],
                            'itemsPerPage': paramsCopy['itemsPerPage'],
                            'includeAllOwners': paramsCopy['includeAllOwners'],
                            'expand': paramsCopy['expand'],
                            'frp': paramsCopy['frp']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                },

                post: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_Post endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                delete: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_Delete endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects/{projectId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{projectId}/g, paramsCopy['projectId']);

                        var query = {
                            'turnOffRecurrenceIfLastInSeries': paramsCopy['turnOffRecurrenceIfLastInSeries'],
                            'deleteChildProject': paramsCopy['deleteChildProject'],
                            'deleteAllProjectsInGroup': paramsCopy['deleteAllProjectsInGroup']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'DELETE', params: query, headers: {} }), suppressErrors);
                    });
                },

                get: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_Get endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects/{projectId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{projectId}/g, paramsCopy['projectId']);

                        var query = {
                            'expand': paramsCopy['expand'],
                            'previous': paramsCopy['previous'],
                            'frp': paramsCopy['frp']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                },

                put: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_Put endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects/{projectId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{projectId}/g, paramsCopy['projectId']);

                        var query = {
                            'updateTaskTargetDates': paramsCopy['updateTaskTargetDates']
                        };
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'PUT', params: query, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                generateNext: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_GenerateNext endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects/{projectId}/generate-next';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{projectId}/g, paramsCopy['projectId']);
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'POST', params: {}, headers: {} }), suppressErrors);
                    });
                },

                calculateDueDate: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_CalculateDueDate endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects/calculate-due-dates';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['dto'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['dto'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                getDefault: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_GetDefault endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects/default';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'clientId': paramsCopy['clientId'],
                            'projectTemplateId': paramsCopy['projectTemplateId'],
                            'ignoreExistingProjectForClient': paramsCopy['ignoreExistingProjectForClient'],
                            'expand': paramsCopy['expand']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                },

                postBulkImport: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_PostBulkImport endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects/import';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                recalculateBudgetInfo: function(params, suppressErrors) {
                    if (console.warn) { console.warn('ProjectV7_RecalculateBudgetInfo endpoint is deprecated.'); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v7/companies/{companyId}/projects/recalculate-budget-info';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['dto'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['dto'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                }

            };
        }]);
}(window.angular));
